import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stayinschool',
  templateUrl: './stayinschool.component.html',
  styleUrls: ['./stayinschool.component.css']
})
export class StayinschoolComponent implements OnInit {

  constructor() { }
  currentYear: number = new Date().getFullYear();

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/stayinschool/stayinschool.component.ts